module.exports = __webpack_public_path__ + "img/orange.642abda1.jpg";